import { render, staticRenderFns } from "./poids-total-livre.vue?vue&type=template&id=c84e5fa6&scoped=true"
import script from "./poids-total-livre.vue?vue&type=script&lang=js"
export * from "./poids-total-livre.vue?vue&type=script&lang=js"
import style0 from "./poids-total-livre.vue?vue&type=style&index=0&id=c84e5fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84e5fa6",
  null
  
)

export default component.exports